export default __webpack_public_path__ + "static/media/Frame.6588d65f.png";